import React from "react";

class ZoomHandler {
  applyZooms(
    scale: number,
    event: React.MouseEvent<HTMLDivElement, MouseEvent>,
    container: Element,
    content: HTMLDivElement
  ) {

    const containerRect = container.getBoundingClientRect();
    const contentRect = content.getBoundingClientRect();

    const mouseX = event.clientX - contentRect.left;
    const mouseY = event.clientY - contentRect.top;

    const containerMouseX = event.clientX - containerRect.left;
    const containerMouseY = event.clientY - containerRect.top;

    const scaledWidth = contentRect.width * scale;
    const scaledHeight = contentRect.height * scale;

    const scaledMouseX = mouseX * scale;
    const scaledMouseY = mouseY * scale;

    const offsetX = containerMouseX - scaledMouseX;
    const offsetY = containerMouseY - scaledMouseY;

    const maxOffsetX = Math.max(0, containerRect.width - scaledWidth);
    const maxOffsetY = Math.max(0, containerRect.height - scaledHeight);

    const finalOffsetX = Math.min(Math.max(offsetX, maxOffsetX), 0);
    const finalOffsetY = Math.min(Math.max(offsetY, maxOffsetY), 0);

    content.style.transform = `translate(${finalOffsetX}px, ${finalOffsetY}px) scale(${scale})`;
    content.style.transformOrigin = `0 0`;

    const newScrollLeft = (containerMouseX - containerRect.width / 2) * scale;
    const newScrollTop = (containerMouseY - containerRect.height / 2) * scale;

    container.scrollLeft = newScrollLeft;
    container.scrollTop = newScrollTop;

    // console.log("Zoom - ", {
    //   scale,
    //   mouseX,
    //   mouseY,
    //   scaledMouseX,
    //   scaledMouseY,
    //   containerMouseX,
    //   containerMouseY,
    //   offsetX,
    //   offsetY,
    //   finalOffsetX,
    //   finalOffsetY,
    //   scaledWidth,
    //   scaledHeight,
    //   newScrollLeft,
    //   newScrollTop,
    // });

    let x = mouseX
    let y = mouseY

    container.scrollLeft = Number(x);
    container.scrollTop = Number(y);
  }
}

enum ZoomMode {
  DISABLE,
  IN,
  OUT,
}

const cursorImage = (zoomMode: ZoomMode) => {
  switch (zoomMode) {
    case ZoomMode.DISABLE:
      return 'default'
    case ZoomMode.IN:
      return 'zoom-in'
    case ZoomMode.OUT:
      return 'zoom-out'
  }
}
export {
  ZoomHandler,
  ZoomMode,
  cursorImage
};
